<template>
  <div>
    <slotbar :slots='67' :slotWidth='250' debug>
      <template v-slot:slot1><v-toolbar><v-btn color='primary'>Botón 1</v-btn></v-toolbar></template>
      <template v-slot:slot2><v-btn color='primary'>Botón 2</v-btn></template>
      <template v-slot:slot3><v-btn color='primary'>Botón 3.1</v-btn><v-btn color='primary'>Botón 3.2</v-btn></template>
    </slotbar>
  </div>
</template>

<script>
import Slotbar from '@/components/custom/slotbar.vue';
export default {
  components: {
    Slotbar
  },
};
</script>
